import React, { useState } from 'react'
import { Drawer, notification, Row, Col, Button } from 'antd'
import { InputBox } from '../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import { uploadConditionalLetterFxn } from '../actions/fcmtAction'

const UploadUnconditionalLetter = (props) => {
  let { visible, onClose, onSubmit, studentId, applicationId } = props
  let [conditionalLetter, setConditionalLetter] = useState({})
  let dispatch = useDispatch()
  const events = {
    chooseConditionalLetter: (e) => {
      let { files } = e.target
      if (files && files.length) {
        setConditionalLetter(files[0])
      }
    },
    handleSubmit: async () => {
      if (!conditionalLetter || (conditionalLetter && !conditionalLetter.name)) {
        return notification.error({
          message: 'Please choose conditional letter'
        })
      }
      let obj = {
        showNotification: true,
        studentId,
        applicationId
      }

      let fd = new FormData()
      fd.append('obj', JSON.stringify(obj))
      if (conditionalLetter && conditionalLetter.name) {
        fd.append('conditionalLetter', conditionalLetter)
      }
      let resp = await dispatch(uploadConditionalLetterFxn(fd))
      if (resp && resp.success) {
        onClose()
      }
    }
  }
  let inputTypes = {
    fields: [
      {
        key: 'conditionalLetter',
        customField: (
          <>
            <InputBox title={'Choose Conditional Letter'}>
              <input type={'file'} className={'form-control'}
                     onChange={(e) => {
                       events.chooseConditionalLetter(e)
                     }}
              />
            </InputBox>
          </>
        )
      }
    ]
  }

  return (
    <Drawer
      width={'35%'}
      title={'Upload Conditional letter'}
      visible={visible}
      onClose={onClose}>
      <div className={'card unizportal'}>
        <Row gutter={16}>
          {inputTypes.fields.map((item) => {
            return (
              <Col span={24} key={item.key}>
                {item.customField}
              </Col>
            )
          })}
          <Col span={24}>
            <button type='submit' className={'btn'} onClick={events.handleSubmit}>
              Submit
            </button>
          </Col>
        </Row>
      </div>
    </Drawer>
  )
}
export default UploadUnconditionalLetter
